import { render, staticRenderFns } from "./urge.vue?vue&type=template&id=1329d769&"
import script from "./urge.vue?vue&type=script&lang=js&"
export * from "./urge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./urge.vue?vue&type=custom&index=0&blockType=el-form&label-width=100px&v-if=dialogOrderPressingBoxVisible"
if (typeof block0 === 'function') block0(component)

export default component.exports